export const navbarWidth = 96;
export const navbarHeight = 66;
